import cleanDeep from 'clean-deep';
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { Types } from "../actions/departmentActions";

//import { v4 as uuidv4 } from 'uuid';

const departmentReducers = (state, action) => {
  switch (action.type) {
    case Types.DEPARTMENTS_GET_LIST: {

      let newState = _.cloneDeep(state);

      console.log('action',action)
      newState.company.settings.departments = _.sortBy(action.payload.departments,'departmentName');

      return newState;
    }
    case Types.DEPARTMENTS_UPDATE: {
      let newState = _.cloneDeep(state);
      newState.company.settings.departments.find(item => item.id == action.id)[action.field] = action.newValue;
      return newState;
    }
    case Types.DEPARTMENTS_ADD: {

      let newState = _.cloneDeep(state);

      newState.company.settings.departments = (newState.company.settings.departments && [...newState.company.settings.departments]) || []

      let {parent, data} = action

      newState.company.settings.departments.push(cleanDeep({
        id: uuidv4(),
        parent,
        ...data,
      }))

      return newState;
    }
    case Types.DEPARTMENTS_REMOVE: {

      let newState = _.cloneDeep(state);

      let id = action.id

      newState.company.settings.departments = newState.company.settings.departments.filter(department => department.id != id)

      return newState;
    }
    default:
      return state;
  }
};

export default departmentReducers;